<template>
  <v-select
    id="advisorUniversity"
    v-model="advisorUniversity"
    :value="advisorUniversity"
    :options="universities"
    :clearable="false"
    aria-label="Advisor University Name"
    class="filters university-select text-sm"
    placeholder="Enter Institution Name"
    @search="searchUniversity"
  />
</template>

<script>
import universitiesListApi from "@/components/mixins/universitiesListApi.js";
import { mapState } from "vuex";

export default {
  name: "UniversityChange",
  mixins: [universitiesListApi],
  props: {
    showCurrent: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      advisorUniversity: null
    };
  },
  computed: {
    ...mapState(["userDetails"]),
  },
  watch: {
    userDetails: {
      handler: function(newval) {
        if (this.showCurrent && (newval && newval.university)) this.setAdvisorUniversity(newval);
      },
      immediate: true,
      deep: true
    },
    advisorUniversity: {
      handler: function(newval) {
        if (newval && newval.value !== this.userDetails.universityId)
          this.changeUniversity(newval);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setAdvisorUniversity(user) {
      this.advisorUniversity = {
        value: user.universityId,
        label: user.university
      };
    },
    changeUniversity(university) {
      let myHeaders = new Headers();
      myHeaders.append("x-jwt-token", this.$store.state.advisor.token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify([
        { op: "replace", path: "/data/university", value: university }
      ]);

      const requestOptions = {
        method: "PATCH",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(
        process.env.VUE_APP_FORMIO_URL +
          "/advisor/submission/" +
          this.$store.getters.getAdvisorId,
        requestOptions
      )
        .then(response => response.json())
        .then(() => {
          this.getUniversity(university);
        })
        .catch(error => console.log("error", error));
    },
    getUniversity(university) {
      fetch(
        process.env.VUE_APP_ENROLLMENT_URL +
          "/api/university/" +
          university.value,
        { headers: { Accept: "application/json" } }
      )
        .then(response => response.json())
        .then(result => {
          this.$store.commit("setAllUniversities", {
            object: result,
            selected: university
          });

          location.reload();
        })
        .catch(error => console.log("error", error));
    }
  }
};
</script>

<style>
.university-select .vs__selected {
  color: #6a7181;
}
</style>
